import SubHeading from "./SubHeading";

const StatCard = ({ title = "", content }) => {
    return (
        <div className="w-full h-16 border border-gray-300 bg-rs-azul/10 shadow flex flex-col justify-center items-center rounded-lg gap-1 p-2">
            <SubHeading text={title} color="red" />
            <SubHeading text={content} color="blue" />
        </div>
    );
};

export default StatCard;